import {
  SET_TYPE_PLAYER_LOCK,
  RESET_TYPE_PLAYER_LOCK,
} from '../../constants/playerLock';
import type { RootState } from '../../store';

export interface PlayerLockState {
  type: unknown;
}

export const initialState: PlayerLockState = {
  type: null,
};

const playerLock = (
  state = initialState,
  { type, payload }: { type: string; payload: unknown }
): PlayerLockState => {
  switch (type) {
    case SET_TYPE_PLAYER_LOCK:
      return { ...state, type: payload };
    case RESET_TYPE_PLAYER_LOCK:
      return { ...state, type: null };
    default:
      return state;
  }
};

export default playerLock;

export const playerLockTypeSelector = (state: RootState) =>
  state?.app?.playerLock?.type;
